module.exports = __webpack_public_path__ + "img/demand.c547ce6e.svg";